import useEmployeeConditionAttributes from "../../employees/hooks/useEmployeeConditionAttributes"
import useRoutingInfo from "../../employees/hooks/useRoutingInfo"

export const useGetAllMedicalQuestionsSkipped = (employeeId: number): boolean => {
  const { data: employeeConditionAttributes } = useEmployeeConditionAttributes(employeeId)
  const { data: currentRoutingInfo } = useRoutingInfo(employeeId)

  if (!employeeConditionAttributes?.isUs) {
    return false
  }
  if (currentRoutingInfo?.medicalInfo == null && currentRoutingInfo?.amabAfabMedicalPreference != null) {
    return true
  }
  return currentRoutingInfo?.medicalInfo?.allMedicalQuestionsSkipped
}
